import { DesktopDarren, DesktopDarren2x, DesktopNichelle, DesktopNichelle2x,
    DesktopTobee, DesktopTobee2x, DesktopSharon, DesktopSharon2x,
    DesktopMelissa, DesktopMelissa2x, DesktopMatthew, DesktopMatthew2x} from './HeroImages/hero_images_config';
import { MobileGoogle, MobileGoogle2x, DesktopGoogle, DesktopGoogle2x, MobileFacebook, MobileFacebook2x, DesktopFacebook, DesktopFacebook2x, MobileMIT,
    MobileMIT2x, DesktopMIT, DesktopMIT2x, MobileNetflix, MobileNetflix2x, DesktopNetflix, DesktopNetflix2x, MobilePaypal, MobilePaypal2x,
    DesktopPaypal, DesktopPaypal2x, MobilePG, MobilePG2x, DesktopPG, DesktopPG2x, MobileIntuit, MobileIntuit2x, DesktopIntuit, DesktopIntuit2x} from './TrustedBy/trusted_by_config';

export const heroImages = [
    {
        title: 'designer_and_animator',
        name: 'Darren',
        src: DesktopDarren,
        desktop: `${DesktopDarren} 1x, ${DesktopDarren2x} 2x`
    },
    {
        title: 'social_media_strategist',
        name: 'Nichelle',
        src: DesktopNichelle,
        desktop: `${DesktopNichelle} 1x, ${DesktopNichelle2x} 2x`
    },
    {
        title: 'voice_over_artist',
        name: 'Tobee',
        src: DesktopTobee,
        desktop: `${DesktopTobee} 1x, ${DesktopTobee2x} 2x`
    },
    {
        title: 'marketing_expert',
        name: 'Sharon',
        src: DesktopSharon,
        desktop: `${DesktopSharon} 1x, ${DesktopSharon2x} 2x`
    },
    {
        title: 'social_media_marketer',
        name: 'Melissa',
        src: DesktopMelissa,
        desktop: `${DesktopMelissa} 1x, ${DesktopMelissa2x} 2x`
    },
    {
        title: 'writer_and_proofreader',
        name: 'Matthew',
        src: DesktopMatthew,
        desktop: `${DesktopMatthew} 1x, ${DesktopMatthew2x} 2x`
    }
];

export const heroCompaniesImages = [
    {
        alt: 'facebook',
        src: DesktopFacebook,
        mobile: `${MobileFacebook} 1x, ${MobileFacebook2x} 2x`,
        desktop: `${DesktopFacebook} 1x, ${DesktopFacebook2x} 2x`
    },
    {
        alt: 'Google',
        src: DesktopGoogle,
        mobile: `${MobileGoogle} 1x, ${MobileGoogle2x} 2x`,
        desktop: `${DesktopGoogle} 1x, ${DesktopGoogle2x} 2x`
    },
    {
        alt: 'MIT',
        src: DesktopMIT,
        mobile: `${MobileMIT} 1x, ${MobileMIT2x} 2x`,
        desktop: `${DesktopMIT} 1x, ${DesktopMIT2x} 2x`
    },
    {
        alt: 'NETFLIX',
        src: DesktopNetflix,
        mobile: `${MobileNetflix} 1x, ${MobileNetflix2x} 2x`,
        desktop: `${DesktopNetflix} 1x, ${DesktopNetflix2x} 2x`
    },
    {
        alt: 'PayPal',
        src: DesktopPaypal,
        mobile: `${MobilePaypal} 1x, ${MobilePaypal2x} 2x`,
        desktop: `${DesktopPaypal} 1x, ${DesktopPaypal2x} 2x`
    },
    {
        alt: 'Intuit',
        src: DesktopIntuit,
        mobile: `${MobileIntuit} 1x, ${MobileIntuit2x} 2x`,
        desktop: `${DesktopIntuit} 1x, ${DesktopIntuit2x} 2x`
    },
    {
        alt: 'P&G',
        src: DesktopPG,
        mobile: `${MobilePG} 1x, ${MobilePG2x} 2x`,
        desktop: `${DesktopPG} 1x, ${DesktopPG2x} 2x`
    }
];

export const MOBILE_IMAGE = '(max-width: 899px)';

export const DESKTOP_IMAGE = '(min-width: 900px)';
